import React, { useState, useEffect } from "react";
import { Container, Table, Pagination, Button } from "react-bootstrap";
import {
  FiEdit, FiTrash2, FiHome,
  FiChevronRight,
} from "react-icons/fi";
import { IoIosArrowForward, IoIosArrowBack } from "react-icons/io";
import { LuPlus } from "react-icons/lu";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getHoliday, deleteHoliday } from "../../store/slices/holiday";
import { toast } from "react-hot-toast";

export default function Holiday() {
  const dispatch = useDispatch();
  const navigate = useNavigate();


  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(25);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);


  const fetchHoliday = () => {
    setIsLoading(true);

    dispatch(getHoliday())
      .unwrap()
      .then((res) => {
        const notices = res?.data || [];
        setData(notices);
        setTotalData(res?.totalDataCount || 0);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch Holiday details ")
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  console.log("data from holidat page ", data);

  useEffect(() => {
    fetchHoliday();
  }, []);

  const navigateHolidaydata = (id) => {
    navigate(`/institute/edit-holiday/${id}`);
    console.log("Holiday list id from Holidaylist page ", id);
  };

  const handleDeleteRow = (id) => {
    if (!id) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Holiday?"
    );

    if (!confirmDelete) return;

    console.log("delete btn in holidaylist page", id);

    dispatch(deleteHoliday(id))
      .unwrap()
      .then(() => {
        toast.success("Holidaydetails deleted successfully ");
        fetchHoliday();
      })
      .catch((err) => {
        toast.error(err || "Failed to delete ");
      });
  };

  // total page and starting index
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  return (
    <Container fluid>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <FiHome />
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/home">Home</Link>

            <FiChevronRight className="separator" />

            <span className="active">Holiday</span>
          </div>

          <Link
            to="/institute/add-holiday"
            className="add-btn"
          >
            <LuPlus />
            Add Holiday
          </Link>

        </div>
      </div>

      <div className="staff-card">

        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th className="text-center">#</th>
                <th className="text-center">From</th>
                <th className="text-center">To</th>
                <th className="text-center">Holiday</th>

                <th className="text-center">Action</th>
              </tr>
            </thead>

            <tbody>
              {paginatedData.map((s, i) => (
                <tr key={i}>

                  <td className="text-center">{i + 1}</td>
                  <td className="text-center">
                    {new Date(s.fromDate).toLocaleDateString("en-GB", {
                      timeZone: "UTC",
                    })}
                  </td>

                  <td className="text-center">
                    {new Date(s.toDate).toLocaleDateString("en-GB", {
                      timeZone: "UTC",
                    })}
                  </td>
                  <td className="text-center">

                    {s.name}
                  </td>



                  <td className="text-center">

                    <button className="edit-btn " onClick={() => navigateHolidaydata(s._id)}><FiEdit /></button>
                    <button className="edit-btn ms-2" onClick={() => handleDeleteRow(s._id)} ><FiTrash2 /></button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        {/* pagination btn */}
        <div className="d-flex flex-row-reverse my-3">
          <Pagination>
            <Button
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
              style={{ background: "transparent", color: "#8451ff", marginRight: "2px", textAlign: "center", borderRadius: "15px" }}
            >
              <IoIosArrowBack />
            </Button>

            <Button
              active
              disabled
              style={{ marginRight: "2px", borderRadius: "20px" }}
            >
              {currentPage}
            </Button>

            <Button
              disabled={currentPage === totalPages || paginatedData.length === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
              style={{ background: "transparent", color: "#8451ff", marginRight: "2px", textAlign: "center", borderRadius: "15px" }}
            >
              <IoIosArrowForward />
            </Button>
          </Pagination>
        </div>
      </div>
    </Container>
  );
}
